module.exports = __webpack_public_path__ + "img/good.212c02d5.svg";